import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import logo from '@/assets/logo.png';

export function Contact(): React.JSX.Element {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white">
            {/* Navigation */}
            <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-24">
                        <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                            <img src={logo} alt="List8.app Logo" className="h-20 w-auto" />
                        </div>
                        <div className="flex items-center space-x-4">
                            <Button variant="ghost" onClick={() => navigate('/login')}>
                                Log in
                            </Button>
                            <Button onClick={() => navigate('/signup')}>
                                Start Today
                            </Button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-8">Contact Us</h1>

                <div className="prose prose-lg text-gray-600">
                    <p className="mb-8">
                        Got a question? Need help with an order? Or maybe you just have a great idea for a new feature? We'd love to hear from you.
                    </p>

                    <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 mb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Get in Touch</h2>

                        <div className="mb-6">
                            <h3 className="font-semibold text-gray-900 mb-1">Email Us</h3>
                            <a href="mailto:support@list8.app" className="text-blue-600 hover:text-blue-700 text-lg">
                                support@list8.app
                            </a>
                        </div>

                        <div>
                            <h3 className="font-semibold text-gray-900 mb-1">Business Hours</h3>
                            <p>Monday - Friday: 9am - 5pm EST</p>
                            <p className="text-sm text-gray-500 mt-1">(But let's be honest, we're often checking emails on weekends too!)</p>
                        </div>
                    </div>

                    <p>
                        We aim to respond to all inquiries within 24 hours. We're a small team, but we care about your success.
                    </p>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-12 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-gray-400">
                        &copy; {new Date().getFullYear()} List8.app. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
}
